export default __webpack_public_path__ + "static/media/nasha.f1fd1384.png";